import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import { message, notification } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { create_feedback_info, update_feedback_info } from '@/api/mjstore-model';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '编辑',
    clazz: 'primary',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      // const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '编辑回访',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'require_info__code',
              label: '诉求号',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'content',
              label: '回访内容',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写回访内容',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '创建日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              placeholder: '请填写创建日期',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: true,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {},
          model: reactive({
            org_id: current_org?.id,
            require_info__code: data.require_info__code,
            is_active: true,
            feedback_info_id: data.id,
            content: data.content,
            date: data.date,
            shop_id: data.shop_id,
            staff_id: data.staff_id,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_feedback_info({
              ...payload,
            })
              .then(() => {
                notification.success({
                  message: '成功',
                  description: '编辑回访成功',
                });
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [];
